export default function SurveyLoadingPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-8 h-8 border-2 border-[#bd9734] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
